<template>
  <div class="row">
    <div class="col-md-2 offset-md-10 mb-2">
      <label class="check-holder ml-0 float-right">
        <span class="check-text display-content"> Select All </span>
        <input type="checkbox" @click="selectAll" v-model="allSelected"/>
        <span class="checkmark"></span>
      </label>
    </div>
  </div>
</template>

<script>
    export default {
        name: "SelectAllPermissionsComponent",
        props: {
            permissions: {
                type: Object,
                required: true
            },
            form: {
                type: Object,
                required: true
            }
        },
        data(){
            return {
                allSelected: false,
                allPermissions: []
            }
        },
        methods: {
            selectAll: function() {
                this.allSelected = !this.allSelected;
                this.form.userPermissions = [];
                let allPermissions = [];
                for (const key in this.permissions) {
                    if (this.permissions.hasOwnProperty(key)) {
                        allPermissions.push(this.permissions[key]);
                    }
                }

                if (this.allSelected) {
                    allPermissions.flat().forEach((value) => {
                        this.form.userPermissions.push(value.id);
                    });
                }
            },
        }
    }
</script>

<style scoped>
  .display-content {
    display: contents !important;
  }
</style>